// import React, { useState } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { toast } from "react-toastify";
// import { setCartDetails } from "../../../../redux/slice/cartSlice";
// import { deleteCart, getCartList } from "../../../../services/cartService";
// import CartsSection from "./CartsSection";

// const Cart = () => {
//   const dispatch = useDispatch();
//   const [loading, setLoading] = useState(false);
//   const [deleteModal, setDeleteModal] = useState({ isOpen: false, data: {} });

//   const cartData = useSelector((state) => state?.cart?.cartListData);
//   const myCartList = cartData?.data || [];
//   const cartSummary = cartData?.metadata?.[0] || {};

//   const fetchCartData = async () => {
//     try {
//       const res = await getCartList();
//       if (res?.docs?.status === 200) {
//         dispatch(setCartDetails(res?.docs));
//       } else {
//         dispatch(setCartDetails({}));
//       }
//     } catch (error) {
//       toast.error("Failed to fetch updated cart.");
//     }
//   };

//   const handleDeleteCartItem = async () => {
//     setLoading(true);
//     try {
//       const res = await deleteCart({ id: deleteModal?.data?._id });
//       if (res?.data?.status === 200) {
//         toast.success(res.data.message);
//         await fetchCartData();
//         setDeleteModal({ isOpen: false, data: {} });
//       } else {
//         toast.error(res?.data?.message || "Failed to delete item.");
//       }
//     } catch (err) {
//       toast.error("Something went wrong.");
//     }
//     setLoading(false);
//   };

//   //   console.log(cartData, "mcl");
//   return (
//     <div className=" mx-auto px-5">
//       <h2 className="text-3xl font-semibold mb-6">Book Images</h2>
//       <CartsSection
//         myCartList={myCartList}
//         cartSummary={cartSummary}
//         deleteCartData={handleDeleteCartItem}
//         deleteModal={deleteModal}
//         setDeleteModal={setDeleteModal}
//         loaded={loading}
//       />
//     </div>
//   );
// };

// export default Cart;

//second cart item chag

// import React, { useState } from "react";
// import Input from "../../../../components/form/Input";
// import Button from "../../../../components/form/Button";
// import Form from "../../../../components/form/Form";
// import Image from "../../../../components/elements/Image";
// import SubscriptionSummary from "../../../../components/sections/front/User/SubscriptionSummary";
// import DeleteModal from "../../../../components/common/DeleteModal";
// import { useDispatch, useSelector } from "react-redux";
// import { toast } from "react-toastify";
// import { setCartDetails } from "../../../../redux/slice/cartSlice";
// import { deleteCart, getCartList } from "../../../../services/cartService";

// const Cart = () => {
//   const dispatch = useDispatch();
//   const [deleteModal, setDeleteModal] = useState({ isOpen: false, data: {} });
//   const [loading, setLoading] = useState(false);

//   const [formValues, setFormValues] = useState({
//     title: "",
//     description: "",
//   });

//   const cartData = useSelector((state) => state?.cart?.cartListData);
//   const myCartList = cartData?.data || [];

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormValues((prev) => ({ ...prev, [name]: value }));
//   };

//   const fetchCartData = async () => {
//     try {
//       const res = await getCartList();
//       if (res?.docs?.status === 200) {
//         dispatch(setCartDetails(res?.docs));
//       }
//     } catch {
//       toast.error("Failed to refresh cart.");
//     }
//   };

//   const handleDeleteCartItem = async () => {
//     setLoading(true);
//     try {
//       const res = await deleteCart({ id: deleteModal?.data?._id });
//       if (res?.data?.status === 200) {
//         toast.success(res.data.message);
//         await fetchCartData();
//         setDeleteModal({ isOpen: false, data: {} });
//       } else {
//         toast.error(res?.data?.message || "Failed to delete item.");
//       }
//     } catch {
//       toast.error("Something went wrong.");
//     }
//     setLoading(false);
//   };

//   return (
//     <Form onSubmit={() => {}}>
//       <div className="grid grid-cols-1 xl:grid-cols-3 gap-6 px-6 py-6">
//         {/* Left Content */}
//         <div className="xl:col-span-2">
//           <div className="mb-6 space-y-4">
//             <h2 className="text-2xl font-semibold text-gray-800">
//               Create Book
//             </h2>
//             <p className="text-gray-500 text-sm">
//               Fill in the details below and review your selected images before
//               placing your order.
//             </p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
//             <Input
//               label="Book Title"
//               inputPlaceholder="Enter book title"
//               inputName="title"
//               value={formValues.title}
//               onChange={handleChange}
//               required
//             />
//             <Input
//               label="Book Description"
//               inputPlaceholder="Enter a brief description"
//               inputName="description"
//               value={formValues.description}
//               onChange={handleChange}
//             />
//           </div>

//           <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
//             {myCartList?.map((item, index) => (
//               <div
//                 key={item._id || index}
//                 className="relative group border rounded overflow-hidden aspect-square bg-gray-50 shadow hover:shadow-md transition"
//               >
//                 <Image
//                   src={item?.product?.url}
//                   alt={item?.productName || "Media"}
//                   classes="w-full h-full object-cover"
//                 />
//                 <button
//                   type="button"
//                   className="absolute top-2 right-2 bg-white text-red-600 hover:bg-red-600 hover:text-white rounded-full p-1 text-xs z-10 shadow transition"
//                   onClick={() => setDeleteModal({ isOpen: true, data: item })}
//                 >
//                   <i className="fa-solid fa-xmark"></i>
//                 </button>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Right Side - Summary */}
//         <div className="sticky top-20">
//           <SubscriptionSummary hideButton />

//           <div className="mt-6">
//             <Button
//               buttonLabel="Proceed to Checkout"
//               buttonFunction={() => {
//                 // Example submission:
//                 console.log({
//                   ...formValues,
//                   cartItems: myCartList,
//                 });
//               }}
//               buttonClasses="!w-full !rounded-lg !bg-chestnut-rose hover:!bg-chestnut-rose-dark !text-white !py-3"
//             />
//           </div>
//         </div>
//       </div>

//       {/* Delete Modal */}
//       <DeleteModal
//         open={deleteModal?.isOpen}
//         onClose={() => setDeleteModal({ isOpen: false, data: {} })}
//         loading={loading}
//         deleteHandler={handleDeleteCartItem}
//       />
//     </Form>
//   );
// };

// export default Cart;

import React, { useState } from "react";
import Input from "../../../../components/form/Input";
import Button from "../../../../components/form/Button";
import Form from "../../../../components/form/Form";
import Image from "../../../../components/elements/Image";
import SubscriptionSummary from "../../../../components/sections/front/User/SubscriptionSummary";
import DeleteModal from "../../../../components/common/DeleteModal";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { setCartDetails } from "../../../../redux/slice/cartSlice";
import {
  checkout,
  deleteCart,
  getCartList,
} from "../../../../services/cartService";
import Textarea from "../../../../components/form/Textarea";
import useForm from "../../../../hooks/useForm";
import useMutation from "../../../../hooks/useMutation";
import { useNavigate } from "react-router-dom";

const validationRules = {
  title: { required: true, message: "Book title is required" },
  description: { required: true, message: "Book description is required" },
};

const Cart = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState({ isOpen: false, data: {} });
  const [loading, setLoading] = useState(false);

  const cartData = useSelector((state) => state?.cart?.cartListData);
  const myCartList = cartData?.data || [];
  const { values, handleChange, handleSubmit, formValidate, errors } = useForm({
    validationRules,
    initialValues: {
      title: "",
      description: "",
    },
  });

  const fetchCartData = async () => {
    try {
      const res = await getCartList();

      if (res?.docs?.status === 200) {
        dispatch(setCartDetails(res?.docs));
      } else {
        dispatch(setCartDetails({}));
      }
    } catch {
      toast.error("Failed to refresh cart.");
    }
  };

  const handleDeleteCartItem = async () => {
    setLoading(true);
    try {
      const res = await deleteCart({ id: deleteModal?.data?._id });
      if (res?.data?.status === 200) {
        toast.success(res.data.message);
        await fetchCartData();
        setDeleteModal({ isOpen: false, data: {} });
      } else {
        toast.error(res?.data?.message || "Failed to delete item.");
      }
    } catch {
      toast.error("Something went wrong.");
    }
    setLoading(false);
  };

  const { mutate: submitCheckout, isPending } = useMutation({
    mutationFn: async (val) => {
      const payload = {
        bookTitle: val.title,
        bookDescription: val.description,
      };
      return await checkout(payload);
    },
    onSuccess: (res) => {
      if (res?.status === 200) {
        toast.success(res?.data?.message || "Proceeding to place order...");
        navigate("/checkout");
      } else {
        toast.error(res?.message || "Checkout failed.");
      }
    },
    onError: () => {
      toast.error("Something went wrong during checkout.");
    },
  });

  return (
    <Form handleSubmit={handleSubmit} onSubmit={submitCheckout}>
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="grid grid-cols-1 xl:grid-cols-3 gap-8">
            {/* Left Content */}
            <div className="xl:col-span-2">
              {/* Header Section */}
              <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 mb-6">
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <h1 className="text-3xl font-bold text-gray-900 mb-2">
                      Create Your Book
                    </h1>
                    <p className="text-gray-600 text-base leading-relaxed">
                      Customize your book details and review your selected
                      images before placing your order.
                    </p>
                  </div>
                  <div className="hidden sm:block">
                    <div className="w-16 h-16 bg-gradient-to-br from-chestnut-rose to-chestnut-rose-dark rounded-full flex items-center justify-center">
                      <i className="fa-solid fa-book text-white text-xl"></i>
                    </div>
                  </div>
                </div>
              </div>

              {/* Form Section */}
              <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 mb-6">
                <div className="mb-6">
                  <h2 className="text-xl font-semibold text-gray-800 mb-1">
                    Book Information
                  </h2>
                  <p className="text-gray-500 text-sm">
                    Provide the basic details for your custom book
                  </p>
                </div>

                <div className="space-y-6">
                  <div className="space-y-2">
                    <Input
                      label="Book Title"
                      inputPlaceholder="Enter your book title"
                      inputName="title"
                      value={values.title}
                      onChange={handleChange}
                      {...formValidate(errors, "title")}
                    />
                  </div>
                  <div className="space-y-2">
                    {/* <Input
                      label="Book Description"
                      inputPlaceholder="Enter a brief description"
                      inputName="description"
                      value={formValues.description}
                      onChange={handleChange}
                    /> */}
                    <Textarea
                      label="Book Description"
                      inputPlaceholder="Enter a brief description"
                      inputName="description"
                      inputValue={values.description}
                      onChange={handleChange}
                      {...formValidate(errors, "description")}
                    />
                  </div>
                </div>
              </div>

              {/* Images Section */}
              <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
                <div className="flex items-center justify-between mb-6">
                  <div>
                    <h2 className="text-xl font-semibold text-gray-800 mb-1">
                      Selected Images
                    </h2>
                    <p className="text-gray-500 text-sm">
                      {myCartList?.length} image
                      {myCartList?.length !== 1 ? "s" : ""} selected for your
                      book
                    </p>
                  </div>
                  <div className="hidden sm:flex items-center space-x-2 text-sm text-gray-500">
                    <i className="fa-solid fa-images"></i>
                    <span>Gallery</span>
                  </div>
                </div>

                {myCartList?.length > 0 ? (
                  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {myCartList?.map((item, index) => (
                      <div
                        key={item._id || index}
                        className="relative group border-2 border-gray-200 rounded-xl overflow-hidden aspect-square bg-gray-50 hover:border-chestnut-rose transition-all duration-300 hover:shadow-lg"
                      >
                        <Image
                          src={item?.product?.url}
                          alt={item?.productName || "Media"}
                          classes="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                        />
                        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300"></div>
                        <button
                          type="button"
                          className="absolute top-2 right-2 bg-white text-red-500 hover:bg-red-500 hover:text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-medium shadow-md hover:shadow-lg transition-all duration-200 transform hover:scale-110"
                          onClick={() =>
                            setDeleteModal({ isOpen: true, data: item })
                          }
                        >
                          <i className="fa-solid fa-xmark"></i>
                        </button>
                        <div className="absolute bottom-2 left-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                          <div className="bg-white bg-opacity-90 backdrop-blur-sm rounded-lg px-2 py-1">
                            <p className="text-xs text-gray-700 truncate">
                              {item?.productName || `Image ${index + 1}`}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-12">
                    <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="fa-solid fa-image text-gray-400 text-2xl"></i>
                    </div>
                    <h3 className="text-lg font-medium text-gray-900 mb-2">
                      No images selected
                    </h3>
                    <p className="text-gray-500 text-sm">
                      Add some images to your cart to create your custom book
                    </p>
                  </div>
                )}
              </div>
            </div>

            {/* Right Side - Summary */}
            <div className="xl:sticky xl:top-24 xl:self-start">
              <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
                <div className="bg-gradient-to-r from-chestnut-rose to-chestnut-rose-dark p-6">
                  <h3 className="text-lg font-semibold text-white mb-1">
                    Order Summary
                  </h3>
                  <p className="text-chestnut-rose-light text-sm opacity-90">
                    Review your book details
                  </p>
                </div>

                <div className="p-6">
                  <SubscriptionSummary hideButton />

                  <div className="mt-6 pt-6 border-t border-gray-200">
                    <Button
                      buttonType="submit"
                      buttonLabel={
                        isPending ? "Processing..." : "Proceed to Checkout"
                      }
                      loading={isPending}
                      isDisable={isPending}
                      buttonClasses="!w-full !rounded-xl !bg-gradient-to-r !from-chestnut-rose !to-chestnut-rose-dark hover:!from-chestnut-rose-dark hover:!to-chestnut-rose !text-white !py-4 !font-semibold !text-base !transition-all !duration-300 !transform hover:!scale-105 !shadow-lg hover:!shadow-xl"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Modal */}
      <DeleteModal
        open={deleteModal?.isOpen}
        onClose={() => setDeleteModal({ isOpen: false, data: {} })}
        loading={loading}
        deleteHandler={handleDeleteCartItem}
      />
    </Form>
  );
};

export default Cart;
